import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceBehfaFilterGroupService {

  constructor(private http: HttpClient) { }

  GetRecord(token: String,fullname: String): Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup?token="+token).pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }


  addeditDeviceBehfaFilterGroup(model: General_Interface,Token: String): Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelDeviceBehfaFilterGroup = {
      id:model.id,
      title: model.title,
      username : Token,
      del:false
    }



    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/AddEdit",modelDeviceBehfaFilterGroup,{headers}).pipe(
      map(data=>{
        return data as General_Interface
      })
    )

  }


  Delete(token: String,
    id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/Delete?id="+id
      +"&token="+token).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }


  
  //#region DeviceBehfa

  GetDeviceBehfa(token: String,
    id: number): Observable<Array<DeviceBehfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/GetDeviceBehfa?token="+token+"&id="+id).pipe(
      map(data=>{
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  
  DeleteDeviceBehfa(token: String,
    id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/DeleteDeviceBehfa?id="+id
      +"&token="+token).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }

  AddDeviceBehfa(DeviceBehfaFilterGroup_id: number,
    DeviceBehfa_id: number,
    Token:String):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:0,
      deviceBehfa_id:DeviceBehfa_id,
      filter_id:DeviceBehfaFilterGroup_id,
      token:Token
    }
    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/AddDeviceBehfa",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  //#endregion


}
